<div *ngIf="folders.length > 0" class="agpr-socialPostFolders-folderList">
    <div class="agpr-socialPostFolders-folderHeadingWrapper">
        <div class="agpr-socialPostFolders-folderSubHeading">
            {{ 'Social.post.details.postCount' | localize }}
        </div>
        <div class="agpr-socialPostFolders-folderHeading">
            {{ 'Mention.details.folders' | localize }}
        </div>
    </div>
    <div class="agpr-socialPostFolders-folderGrid">
        <ul [attr.aria-label]="'Mention.details.folders' | localize">
            <li
                *ngFor="let folder of shownFolders"
                class="agpr-socialPostFolders-folderListItem"
            >
                <div class="agpr-socialPostFolders-folderName">
                    <a
                        class="agpr-socialPostFolders-folderLink"
                        target="_blank"
                        [href]="
                            appBaseHref + 'Monitoring/mentions/folder/' + folder.id
                        "
                    >
                        {{ folder.name }}
                    </a>
                </div>
                <div class="agpr-socialPostFolders-folderRightColumn">
                    <div class="agpr-socialPostFolders-folderMentionCount">
                        {{ folder.totalMentions }}
                    </div>
                    <div class="agpr-socialPostFolders-folderRemovalButton">
                        <agpr-button
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-square-x"
                            tooltip="Mention.details.removeFromFolder"
                            tooltipPosition="left"
                            (click)="removeMentionFromFolder(folder)"
                        ></agpr-button>
                    </div>
                </div>
            </li>
        </ul>
        <agpr-button
            *ngIf="foldersToShow < folders.length || folders.length > 3"
            class="agpr-socialPostFolders-folderButton"
            [style]="buttonTypes.link"
            (click)="foldersToShow < folders.length ? viewMoreFolders() : viewLessFolders()"
            aria-live="polite"
            [attr.aria-expanded]="foldersToShow < folders.length ? false : true"
        >
            {{ foldersToShow < folders.length ?
                ( 'Mention.details.foldersViewMore' | localize: {'folderCount': folders.length - foldersToShow} ) :
                ( 'Mention.details.foldersViewLess' | localize )
            }}
            <span
                class="agpr-socialPostFolders-folderButtonIcon fa-solid"
                [ngClass]="{
                    'fa-angle-down': foldersToShow < folders.length,
                    'fa-angle-up': foldersToShow > defaultFoldersToShow
                }"
                aria-hidden="true"
            ></span>
        </agpr-button>
    </div>
</div>
